exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Og13d{position:relative;padding:0 18px 16px;font-weight:400;cursor:default;min-height:100px}._32c5u{font-size:21px;margin-bottom:4px;font-weight:700;max-width:500px}.ZyAI2{font-size:12px;color:#aaa;font-weight:400;margin:0}._2d7ou,._3Ik3K,._TY4k{color:#999;font-size:12px;display:inline-block;margin-right:20px}._2d7ou>i{font-size:14px;margin-right:.2em}._3-gGk{font-size:22px;text-align:right;width:100%}._3-gGk._3A3Wy{font-size:16px}._28jGj{margin-bottom:2px}._3xUuW{font-size:22px;font-weight:700;white-space:nowrap}._3xUuW:not(:first-of-type){font-weight:400;font-size:14px}._11gFs{margin-left:-7px}._1qNLx,._11gFs{display:inline-block}._1qNLx{vertical-align:top;font-weight:600;padding:5px 10px;font-size:14px;background:#ffd906;border-radius:2px;color:#000;text-decoration:none;margin:1px 0 27px}._1qNLx:hover{background:#ffc107}._1I-8t{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:end;align-items:end}._1I-8t,._144Vd{-webkit-box-align:end;-ms-flex-align:end}._144Vd{display:-webkit-box;display:-ms-flexbox;display:flex;align-items:flex-end}.LBbJt{margin-bottom:5px}", ""]);

// exports
exports.locals = {
	"root": "Og13d",
	"title": "_32c5u",
	"h1": "ZyAI2",
	"id": "_TY4k",
	"date": "_3Ik3K",
	"views": "_2d7ou",
	"price": "_3-gGk",
	"contractPrice": "_3A3Wy",
	"priceList": "_28jGj",
	"priceItem": "_3xUuW",
	"favoriteContainer": "_11gFs",
	"clarifyPrice": "_1qNLx",
	"blockRightFlex": "_1I-8t",
	"yearSection": "_144Vd",
	"LeasingButton": "LBbJt"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertLeasingTitle/AdvertLeasingTitle.css
// module id = 3285
// module chunks = 32